// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

import Login             from '@/views/Login.vue';
import MainMenu          from '@/views/MainMenu.vue';
import CustomerMenu      from '@/views/CustomerMenu.vue';
import CustomerForm      from '@/views/CustomerForm.vue';
import CustomerOverview  from '@/views/CustomerOverview.vue';
import EditCustomer      from '@/views/EditCustomer.vue';
import ItemMenu          from '@/views/ItemMenu.vue';
import ItemList          from '@/views/ItemList.vue';
import AddArticle        from '@/views/AddArticle.vue';
import ApplyDiscount     from '@/views/ApplyDiscount.vue';
import SalesPage         from '@/views/SalesPage.vue';
import AdminMenu         from '@/views/AdminMenu.vue';
import Auszahlung        from '@/views/Auszahlung.vue';
import Analysis          from '@/views/Analysis.vue';
import PayoutsOverview   from '@/views/PayoutsOverview.vue';
import PayoutDownload    from '@/views/PayoutDownload.vue';

const routes = [
  { path: '/login',  name: 'Login',       component: Login },
  { path: '/',       redirect: '/login' },

  { path: '/mainmenu',        name: 'MainMenu',       component: MainMenu,       meta: { requiresAuth: true } },
  { path: '/customers',       name: 'CustomerMenu',   component: CustomerMenu,   meta: { requiresAuth: true } },
  { path: '/customers/create',name: 'CustomerForm',   component: CustomerForm,   meta: { requiresAuth: true } },
  { path: '/customers/overview', name: 'CustomerOverview', component: CustomerOverview, meta: { requiresAuth: true } },
  { path: '/customers/edit/:id', name: 'EditCustomer', component: EditCustomer, props: true, meta: { requiresAuth: true } },

  { path: '/items',           name: 'ItemMenu',       component: ItemMenu,       meta: { requiresAuth: true } },
  { path: '/items/list',      name: 'ItemList',       component: ItemList,       meta: { requiresAuth: true } },
  { path: '/articles/create', name: 'AddArticle',     component: AddArticle,     meta: { requiresAuth: true } },
  { path: '/items/discount',  name: 'ApplyDiscount',  component: ApplyDiscount,  meta: { requiresAuth: true } },

  { path: '/sales',           name: 'SalesPage',      component: SalesPage,      meta: { requiresAuth: true } },

  { path: '/admin',           name: 'AdminMenu',      component: AdminMenu,      meta: { requiresAuth: true } },
  { path: '/admin/auszahlung',name: 'Auszahlung',     component: Auszahlung,     meta: { requiresAuth: true } },

  { path: '/admin/payouts-overview', name: 'PayoutsOverview', component: PayoutsOverview, meta: { requiresAuth: true } },
  { path: '/admin/payouts/:id/download', name: 'PayoutDownload', component: PayoutDownload, props: true, meta: { requiresAuth: true } },

  { path: '/analysis',        name: 'Analysis',       component: Analysis,       meta: { requiresAuth: true } },

  // Optional: alle unbekannten Pfade zurückleiten
  { path: '/:pathMatch(.*)*', redirect: '/' }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// --- HIER IST DER WICHTIGE GUARD ---
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('accessToken');

  // 1) Nicht eingeloggt + geschützte Route → Login
  if (to.meta.requiresAuth && !token) {
    return next({ name: 'Login' });
  }

  // 2) Bereits eingeloggt + Login-Route aufgerufen → MainMenu
  if (to.name === 'Login' && token) {
    return next({ name: 'MainMenu' });
  }

  // 3) Ansonsten normal weiter
  next();
});
// --- ENDE GUARD ---

export default router;
